import { BottomSheetStackApi } from "@/components/BottomSheet";
import { SheetsEnum } from "../enums/sheets.enum";
import { SwitchSheetsHeaderComponentsResult } from "../types/switch-sheets-header-components.type";
import { SheetsType } from "../types/sheets.type";
import Stepper from "@/components/Stepper";
import tw from "twin.macro";
import { useTranslation } from "react-i18next";
import { useCommandTimeProgression } from "@/routes/area-aggregate/hooks/use-command-time-progression";
import { getStepper } from "../utils/get-stepper";

export const StepperContainer = tw.div`flex-1 pt-1`;

export function switchSheetsHeaderComponents({
  sheet,
}: {
  sheet: BottomSheetStackApi<SheetsType>;
}): SwitchSheetsHeaderComponentsResult {
  switch (sheet.visibleView?.id) {
    case SheetsEnum.ACTION_IN_PROGRESS:
      const currentAction = sheet.visibleView?.context.currentAction;

      return {
        hasHeaderComponent: true,
        headerComponent: () => {
          const { t: translator } = useTranslation();
          const { isOutOfTimeChrono } = useCommandTimeProgression();

          const stepper = getStepper({
            currentAction,
            isOutOfTimeChrono,
            translator,
          });

          return (
            <StepperContainer>
              <Stepper steps={stepper} />
            </StepperContainer>
          );
        },
      };
    default:
      return { hasHeaderComponent: false };
  }
}
